export const DemolitionB3NavOptions = [
  {
    label: 'Úpravy terénu a řešení vegetace po odstranění stavby',
    target: 'b3.terrainModifications',
  },
];
